import { useQuery } from "react-query";
import { uncoveryApi } from "..";

const fetchMapsByEntityId = async (entityId, mapId) => {
  const query = `/entities/${entityId}/cartographies/${mapId}`;
  const { data } = await uncoveryApi.get(query);
  return data.data;
};

export default function useFetchMapsByEntityId(entityId, mapId) {
  return useQuery(
    ["map", entityId, mapId],
    () => fetchMapsByEntityId(entityId, mapId),
    {
      enabled: !!entityId && !!mapId,
      retry: false,
    }
  );
}
